























import { Component, Prop, Mixins } from 'vue-property-decorator';
import { MixinChartGroupEvolution } from '@/plugins/podolib/services/helper/mixins/chart/evolution';
import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
import { TMode } from '@/plugins/podolib/services/helper/mixins/chart';
//
import ChartEvolutionOscillatingPhasePropulsionSpeed from '@/components/charts/evolution/ChartEvolutionOscillatingPhasePropulsionSpeed.vue';
import ChartEvolutionOscillatingPhaseStrideLength from '@/components/charts/evolution/ChartEvolutionOscillatingPhaseStrideLength.vue';
import ChartEvolutionOscillatingPhaseWalkingSpeed from '@/components/charts/evolution/ChartEvolutionOscillatingPhaseWalkingSpeed.vue';
import ChartEvolutionOscillatingPhaseCadence from '@/components/charts/evolution/ChartEvolutionOscillatingPhaseCadence.vue';
import ChartEvolutionOscillatingPhasePropulsionRatio from '@/components/charts/evolution/ChartEvolutionOscillatingPhasePropulsionRatio.vue';
import ChartEvolutionOscillatingPhaseClearance from '@/components/charts/evolution/ChartEvolutionOscillatingPhaseClearance.vue';

@Component({
  components: {
    ChartEvolutionOscillatingPhasePropulsionSpeed,
    ChartEvolutionOscillatingPhaseStrideLength,
    ChartEvolutionOscillatingPhaseWalkingSpeed,
    ChartEvolutionOscillatingPhaseCadence,
    ChartEvolutionOscillatingPhasePropulsionRatio,
    ChartEvolutionOscillatingPhaseClearance,
  },
})
export default class ChartsGroupEvolutionOscillatingPhase extends Mixins(MixinChartGroupEvolution) {}
